var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {
            let errorMsg = 'The file is too big.'
            if ( $('html').is(':lang(de-DE)') ) {
                errorMsg = 'Die Datei ist zu groß';
            }

            const fileInput = $('.fz-form__upload-fake .wpcf7-drag-n-drop-file');
            fileInput.on('change',function(e){
                var file = this.files[0];
                if (file.size > 10485760) {
                    //alert("Too large file. Only files smaller than 10MB can be uploaded.");
                    //$(this).replaceWith('<input class="input-file" type="file">');

                    $('.wpcf7-response-output').text(errorMsg);
                    // Die Datei ist zu groß


                    $(this).closest('form').addClass('invalid').removeClass('init');

                    return false;
                } else {
                    $('.wpcf7-response-output').text('');
                    $(this).closest('form').removeClass('invalid').addClass('init');

                    for (let a=0; a<e.target.files.length; a++) {
                        let filename = e.target.files[a].name;

                        if (filename.substring(3,11) === 'fakepath') {
                            filename = filename.substring(12);
                        }

                        const list = $('.fz-form__upload-file');
                        list.append('<span>'+ filename +'</span>');
                    }
                }
            });

            const input = $('.fz-form__form-group:not(.fz-form__upload) input:not([type="checkbox"])');
            const textarea = $('.fz-form__form-group textarea');

            input.each(function(){
                const classNames = $(this).parent().prop('class');
                if (!$(this).hasClass('wpcf7-submit')){
                    $(this).unwrap();
                    $(this).parent().wrapInner( "<span class='" + classNames + "'></span>");
                }
            });
            textarea.each(function(){
                const classNames = $(this).parent().prop('class');
                $(this).unwrap();
                $(this).parent().wrapInner( "<span class='" + classNames + "'></span>");
            });

            input.on('keyup',function(){
                if ($(this).val() !== ''){
                    $(this).addClass('stay');
                } else {
                    $(this).removeClass('stay');
                }
            });
            textarea.on('keyup',function(){
                if ($(this).val() !== ''){
                    $(this).addClass('stay');
                } else {
                    $(this).removeClass('stay');
                }
            });

            if ($('html').is(':lang(de-DE)')) {
                $('.e-mail-lang').html('E-Mail');
            }

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=custom-form', initializeBlock);
    }
});
